import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { pdfjs } from "react-pdf";

// Set workerSrc to avoid webpack bundling issues
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// CVE-2024-4367 (GHSA-wgrm-67xf-hhpq / GHSA-87hq-q4gp-9wr4): no eval in pdf.js; module-level so the Document never reloads per render.
const PDF_OPTIONS = Object.freeze({ isEvalSupported: false });

const PDFModal = ({ show, onHide, pdfUrl, title }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleDownloadPdf = async () => {
    const response = await fetch(pdfUrl);
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", title + ".pdf"); // or any other extension
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="modal-style-2 pdf-viewer-modal">
      <Modal.Header closeButton>
        <Modal.Title as="h3" className="w-100 modal-pdf-title text-center">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Document
          file={pdfUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          options={PDF_OPTIONS}
          className="pdf-document d-flex justify-content-center w-100"
        >
          <Page pageNumber={pageNumber} />
        </Document>
        <div className="pdf-page-navigation text-center">
          <p>
            Page {pageNumber} of {numPages}
          </p>
          <div className="d-flex justify-content-between align-items-center mx-4">
            <Button onClick={() => setPageNumber(pageNumber - 1)} disabled={pageNumber <= 1} className="btn-primary">
              Previous
            </Button>
            <button onClick={handleDownloadPdf} style={{ height: "50px" }} className="btn-primary downloadWhiteBtn">
              Download
              <img
                src={require("../../../../assets/images/icon-downloadWhite.svg").default}
                alt=""
                className="delete-icon mx-2 mb-1"
                // onClick={onPropertyDocumentDelete}
              />
            </button>
            <Button
              onClick={() => setPageNumber(pageNumber + 1)}
              disabled={pageNumber >= numPages}
              className="btn-primary"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PDFModal;
